import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class AlertaService {
	private data = null;
	private url = environment.serviceApi;

	constructor(public http: Http) { }

	getAlertas(usuario_id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/alertas/' + usuario_id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getStatus(status) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/alertas/status/' + status)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getStatusCount(status, usuario_id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/alertas/statuscount/' + status + '/' + usuario_id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	finalizaAlerta(id) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/alertas/finaliza/' + id, {})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}
}
